module.exports = __webpack_public_path__ + "media/images/team/SKim-500fe30fc06a03be0a6d87c96f6aacfa.jpg";